"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Half = _ref => {
  let {
    title,
    content,
    image,
    orderLast,
    primaryBtnHref,
    primaryBtnText,
    imageStyle,
    equalCols
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: `grid grid-cols-1 sm:gap-8 lg:gap-16 
      ${equalCols ? "sm:grid-cols-2" : "sm:grid-cols-3 "}
     `,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `lg:py-5 ${orderLast ? "order-last" : ""}`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `${!orderLast ? "text-center sm:text-start" : ""} `,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
          className: `inline-flex items-baseline max-w-[546px] gap-6 ${!orderLast ? "text-[34px] leading-[40.8px]" : ""}`,
          children: title
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: `my-5 ${!orderLast ? "text-center sm:text-start" : ""}`,
        children: content
      }), primaryBtnText !== undefined ? /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
        href: primaryBtnHref,
        className: "primary-btn inline-flex items-center",
        children: primaryBtnText
      }) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: `flex justify-center items-center  ${imageStyle} ${equalCols ? "" : "col-span-2"}  `,
      children: image
    })]
  });
};
var _default = Half;
exports.default = _default;